// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportDraftContent_container__nCYYh","contentWrapper":"ReportDraftContent_contentWrapper__2nxMI","loadingWrapper":"ReportDraftContent_loadingWrapper__1Zrs6"};